import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import CompleteRegistration from "../../components/CompleteRegistration";
import StripeWrapper from "../../components/StripeWrapper"

function Registration() {
  let history = useHistory();

  useEffect(() => {
    if (localStorage.getItem("accessToken")) {
      history.push("/");
    }
  }, []);
  return (
    <StripeWrapper>
      <CompleteRegistration/>
    </StripeWrapper>
  );
}

export default Registration;
